<template>
  <main class="content">
    <!-- content -->
    <section class="referral">
      <div class='container'>
        <div class="referral__wrapper">
          <h1 class="referral__title">Реферальная программа</h1>
          <p class="referral__subtitle">Зарабатывайте вместе с нами!
            Вы нам - трафик и записи на обучение. Мы Вам - % от всех оплат.
            Платим день в день!
          </p>
          <section id="9bdf30ead07c6fed1154849581b770780fbc958f"></section>
          <div class="referral-work">
            <h1 class="referral-work__title">Как это работает</h1>
            <div class="for__list list-for">
              <div class="list-for__top">
                <div class="list-for__number">1</div>
                <div class="list-for__text referral-work-text">
                  Если Вы уже «попались» и грозит лишение прав, суд уже назначен или его дата неизвестна – переходите в «Расписание», выбирайте дату ближайшего обучения по Вашей ситуации и сохраните свой водительское удостоверение
                </div>
              </div>
              <div class="list-for__top">
                <div class="list-for__number">2</div>
                <div class="list-for__text referral-work-text">
                  Если Вы уже «попались» и грозит лишение прав, суд уже назначен или его дата неизвестна – переходите в «Расписание», выбирайте дату ближайшего обучения по Вашей ситуации и сохраните свой водительское удостоверение
                </div>
              </div>
              <div class="list-for__top">
                <div class="list-for__number">3</div>
                <div class="list-for__text referral-work-text">
                  Если Вы уже «попались» и грозит лишение прав, суд уже назначен или его дата неизвестна – переходите в «Расписание», выбирайте дату ближайшего обучения по Вашей ситуации и сохраните свой водительское удостоверение
                </div>
              </div>
            </div>
          </div>
          <div class="referral-incoming">
            <h1 class="referral-incoming__title">Как отслеживаются доходы</h1>
            <div class="referral-incoming__picture">
              <picture><source srcset="/static/assets//img/referral-incoming/1.svg" type="image/webp"><img src="/static/assets//img/referral-incoming/1.svg" alt="" /></picture>
            </div>
          </div>
          <div class="referral-total">
            <h1 class="referral-total__title">Результаты месяца</h1>
            <div class="referral-total__col">
              <div class="referral-total__item">
                <div class="referral-total__top">
                  <div class="referral-total__price">14 000</div>
                  <div class="referral-total__val">руб</div>
                </div>
                <p class="referral-total__text">заработано максимально</p>
              </div>
              <div class="referral-total__item">
                <div class="referral-total__top">
                  <div class="referral-total__price">300 000</div>
                  <div class="referral-total__val">руб</div>
                </div>
                <p class="referral-total__text">заработано максимально</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </main>
</template>

<script>
export default {
  name: 'refereals',
  data () {
    return {
    }
  },
  mounted () {
    var script = document.getElementById('9bdf30ead07c6fed1154849581b770780fbc958f')
    var par = script.parentNode
    script.parentNode.style.overflow = 'hidden'

    var iframe = document.createElement('iframe')
    iframe.src = 'https://shkola-avtourist.getcourse.ru/pl/lite/widget/widget' + '?' + window.location.search.substring(1) + '&id=224618' + '&ref=' + encodeURIComponent(document.referrer) + '&loc=' + encodeURIComponent(document.location.href)
    iframe.style.width = '100%'
    iframe.style.height = '0px'
    iframe.style.border = 'none'
    iframe.style.overflow = 'hidden'
    iframe.className = '375'
    iframe.id = '7cf515c0fac518bc519de92e102f73eb7156069b' + '_' + iframe.className
    // name можно получить изнутри iframe
    iframe.name = iframe.className

    var iframeId = iframe.id

    var gcEmbedOnMessage = function (e) {
      var insertedIframe = document.getElementById(iframeId)
      if (!insertedIframe) {
        return
      }

      if (e.data.uniqName === '9bdf30ead07c6fed1154849581b770780fbc958f') {
        if (e.data.height) {
          if (e.data.iframeName) {
            if (e.data.iframeName === iframe.name) {
              // par.style.height = (e.data.height) + 'px'
              insertedIframe.style.height = (e.data.height) + 'px'
            }
          } else {
            // par.style.height = (e.data.height) + 'px'
            insertedIframe.style.height = (e.data.height) + 'px'
          }
        }
      }
    }

    if (window.addEventListener) {
      window.addEventListener('message', gcEmbedOnMessage, false)
    } else if (window.attachEvent) {
      window.attachEvent('onmessage', gcEmbedOnMessage)
    } else {
      window['onmessage'] = gcEmbedOnMessage
    }

    script.parentNode.insertBefore(iframe, script)
    par.removeChild(script)

    var getLocation = function (href) {
      var l = document.createElement('a')
      l.href = href
      return l
    }

    var currentScript = document.currentScript || (function () {
      var scripts = document.getElementsByTagName('script')
      return scripts[scripts.length - 1]
    })()
    // eslint-disable-next-line
    var domain = ((getLocation(currentScript.src)).hostname)
  },
  watch: {
  },
  methods: {
    showModal (id, text) {
      this.$root.requestModal = id
      this.$root.requestModalText = text
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/referals.vue